import React from 'react';
import PropTypes from 'prop-types';

function TVFieldTypeRenderer(props) {
  const { value } = props;

  return (
    <span className="label label-default text-uppercase">{value}</span> 
  );
}

TVFieldTypeRenderer.propTypes = {
  value: PropTypes.string.isRequired,
}
TVFieldTypeRenderer.defaultProps = {
}

export default TVFieldTypeRenderer;
